import ContactForm from "./Form"

function Contact() {
    return (
       <ContactForm></ContactForm>
    )
}

export default Contact
